'use strict';
var EqpPartnersController = /** @class */ (function () {
    /*@ngInject*/
    function EqpPartnersController(EqpPartnersService, ProductService, $state, $scope, seoMetaService) {
        this.loadMore = function () {
            var increamented;
            if (this.showViewMore == true) {
                increamented = this.limit + 10;
            }
            else {
                increamented = 3;
            }
            if (increamented > this.eqpPartners.length) {
                this.limit = this.eqpPartners.length;
                this.showViewLess = true;
                this.showViewMore = false;
            }
            else {
                this.limit = increamented;
                this.showViewLess = false;
                this.showViewMore = true;
            }
        };
        this.limit = 3;
        this.showViewMore = true;
        this.showViewLess = false;
        this.$state = $state;
        this.EqpPartnersService = EqpPartnersService;
        this.ProductService = ProductService;
        this.$scope = $scope;
        this.seoMetaService = seoMetaService;
        this.seoMetaService.updateSeoMetaData(this, 'EqpPartnersController');
    }
    EqpPartnersController.prototype.$onInit = function () {
        var _this = this;
        this.EqpPartnersService.getEqpPartners()
            .then(function (response) {
            _this.ProductService.getBrands()
                .then(function (brands) {
                response.forEach(function (item) {
                    var match = brands.currentPage.find(function (brand) { return item.brand === brand.brand; });
                    if (match) {
                        item['brandId'] = match.brandId;
                    }
                });
                _this.eqpPartners = response;
            });
        });
    };
    EqpPartnersController.prototype.eqppartnerbrands = function (searchItem) {
        var state = {
            searchFilter: searchItem.brand.split(' ').join('-') + '-B' + searchItem.brandId
        };
        this.$state.go('searchResults', state); // switch views to the results page.
    };
    ;
    return EqpPartnersController;
}());
export default EqpPartnersController;
//# sourceMappingURL=eqp-partners.controller.js.map